import { useEffect, useState /* , useMemo */ } from 'react';

import { Document, Image, Page, Text, View, Link } from '@react-pdf/renderer';

import { PropTypes } from 'prop-types';

import useLocales from '../../../hooks/useLocales';
import CultureObjectPrintStyle from './CultureObjectPrintStyle';

const atributtes = [
  'Author',
  'Date',
  'Title translation',
  'Subtitle',
  'Other title',
  'Part title',
  'Edition, nr',
  'Periodicity',
  'Source',
  'Co-authors',
  'Book designer',
  'Director',
  'Writer',
  'Screenwriter',
  'Director of photography',
  'Composer',
  'Dramaturge',
  'Costumes',
  'Editing',
  'Sound editor',
  'Post-production supervisor',
  'Actors',
  'Main director',
  'Performer',
  'Author of dialog',
  'Curator',
  'Other',
  'Publisher',
  'Ilustrator',
  'Photographer',
  'Translator',
  'Keeper',
  'Actor',
  'Issuer note',
  'Genre',
  'Style',
  'General use',
  'Series',
  'Producer',
  'ISBN',
  'ISSN',
  'Place of origin',
  'Date of finding',
  'Country',
  'County',
  'Municipality',
  'Street',
  'Number of census sheet',
  'Box number',
  'Language',
  'Source language',
  'Material',
  'Technique used',
  'Last',
  'Format',
  'Physical description',
  'Labelling',
  'Description',
  'Author of assignment',
  'Date of Declaration NKP',
  'Date of recording',
  'Keywords',
  'Originality',
  'Fund department',
  'Owner',
  'Asset number',
  'Identifier',
  'License',
  'The exercise of rights',
  'URL',
  "Object's rights",
  'Category',
  'Subcategory',
];

CultureObjectPrintDetail.propTypes = {
  culturalObject: PropTypes.object,
  digitalObjects: PropTypes.any,
  // related: PropTypes.any,
};

export default function CultureObjectPrintDetail({ culturalObject /* , related */, digitalObjects }) {
  const { currentLang, translate } = useLocales();
  const styles = CultureObjectPrintStyle;
  const [licenceData, setLicenceData] = useState(null);
  const capitalizeFirst = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

  const dateModifed = {
    name: 'Update date',
    values: [
      culturalObject.dateModified
        ? new Date(culturalObject.dateModified).toLocaleString(currentLang.label, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '-',
    ],
  };

  const sortedArray = atributtes.reduce(
    (acc, item) => {
      if (item === 'Category' && culturalObject.categories?.length) {
        const parents = culturalObject.categories
          .filter((e) => e.parentKey === '10' && e.parentKey !== '70')
          .map((e) => e.name);
        const children = culturalObject.categories
          .filter((e) => e.parentKey !== '10' && !culturalObject.isCensusSheet)
          .map((e) => e.name);
        if (parents.length) {
          if (children.length) {
            acc.push({ name: item, values: parents }, { name: 'Subcategory', values: children });
          } else {
            acc.push({ name: item, values: parents });
          }
        }
      }
      const array = culturalObject.key ? culturalObject.attributes : culturalObject.metadata;
      if (array) {
        const found = array.find((e) => e.name === item);
        if (found) {
          acc.push(found);
        }
      }
      return acc;
    },
    [culturalObject]
  );

  const drawMetadata = (item, id) => (
    <Text style={{ fontFamily: 'Lato', paddingTop: '1px', paddingBottom: '1px' }} key={`name${id}`}>
      {currentLang.value === 'en'
        ? item.name
        : translate(
            item.name
              ? `objects.metadata.${item.name}`
              : `objects.metadata.${!item.name.includes(':') ? item.name : item.name.split(':').join('_')}`
          )}
      {': '}
      <Text style={{ fontFamily: 'Lato', fontWeight: 'bold' }} key={`value${id}`}>
        {item.values.map((value, i) => `${value}${i !== item.values.length - 1 ? ', ' : ''}`)}
      </Text>
    </Text>
  );

  const checkValid = (object) => {
    switch (object?.type) {
      case '3D_MODEL':
        return object?.model?.fileUrl !== undefined;
      default:
        return object?.thumbnail?.fileUrl !== undefined;
    }
  };

  // const count = useMemo(() => {
  //   let tmpCount = 0;
  //   digitalObjects.forEach((obj) => {
  //     if (checkValid(obj)) {
  //       tmpCount += 1;
  //     }
  //   });
  //   return tmpCount;
  // }, [digitalObjects]);

  // const drawDos = (item, idx) => (
  //   <Image
  //     key={item.thumbnail + idx}
  //     src={item?.thumbnail?.fileUrl}
  //     style={{
  //       ...styles.imageList,
  //       left: `${(idx % 3) * 191}px`,
  //       top: `${Math.floor(idx / 3) * 151 + 8}px`,
  //     }}
  //   />
  // );
  // let validIdx = 0;

  useEffect(() => {
    if (culturalObject.license) {
      switch (culturalObject.license) {
        case 1:
          setLicenceData({
            name: 'CC-BY',
            link: 'https://creativecommons.org/licenses/by/4.0/',
            description: [
              {
                icon: 'material-symbols:man',
                translatableText: 'objects.giveCredit',
              },
            ],
          });
          break;
        case 2:
          setLicenceData({
            name: 'CC-BY-NC-ND',
            link: 'https://creativecommons.org/licenses/by-nc-nd/4.0/',
            description: [
              {
                icon: 'mdi:money-off',
                translatableText: 'objects.doNotCommerical',
              },
              {
                icon: 'ic:baseline-equals',
                translatableText: 'objects.doNotDerivate',
              },
              {
                icon: 'material-symbols:man',
                translatableText: 'objects.giveCredit',
              },
            ],
          });
          break;
        default:
          break;
      }
    }
  }, [culturalObject]);

  const drawThumbs = (item, idx) => (
    <View key={`wiew-${item.thumbnail}${idx}`}>
      <Image
        key={item.thumbnail + idx}
        src={item?.thumbnail?.fileUrl}
        style={{
          marginBottom: '5px',
        }}
      />
    </View>
  );

  return (
    culturalObject && (
      <Document
        title={culturalObject.name}
        author={culturalObject.author}
        subject={culturalObject.name}
        keywords={culturalObject.name}
        creator="BRAIN:IT"
        producer="BRAIN:IT"
        language={currentLang.label}
      >
        <Page size="A4" style={styles.page}>
          {digitalObjects.map(
            (item, idx) => {
              if (checkValid(item)) {
                return drawThumbs(item, idx);
              }
              return null;
            }
            // item?.images.map((i, ids) => {

            // })
          )}
          {/* <Image
              src={
                culturalObject.thumbnail !== undefined && culturalObject.thumbnail !== ''
                  ? `${process.env.REACT_APP_API_URL}/image/download/${culturalObject.thumbnail}?sizeIndex=0`
                  : ''
              }
            /> */}

          {/* <View wrap={false}>
            <View style={{ height: `${Math.ceil(count / 3) * 151 + 8}px` }}>
              {digitalObjects.map((item) => {
                if (checkValid(item)) {
                  const validItem = drawDos(item, validIdx);
                  validIdx += 1;
                  return validItem;
                }
                return null;
              })}
            </View>
          </View> */}
          {licenceData && (
            <View style={{ paddingBottom: '20px' }}>
              <View>
                {!culturalObject.license || culturalObject.license === 0 ? (
                  <Text>{translate('objects.licenceCC')}</Text>
                ) : (
                  <>
                    <Text
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Lato',
                        fontWeight: 'bold',
                        paddingTop: '1px',
                        paddingBottom: '1px',
                      }}
                    >
                      {licenceData?.name} {translate('objects.license')}
                      {translate('objects.licenseBYusage')}
                    </Text>
                    {licenceData?.description.map((item) => (
                      <View key={item.icon}>
                        {/* <Avatar
                          style={{
                            width: 23,
                            height: 23,
                            backgroundColor: 'rgba(255,0,0, 0)',
                            border: '2px solid white',
                          }}
                        >
                          <Iconify color="#fff" icon={item.icon} width={17} height={17} />
                        </Avatar> */}
                        <Text
                          style={{
                            fontSize: '12px',
                            fontFamily: 'Lato',
                            fontWeight: 'bold',
                            paddingTop: '1px',
                            paddingBottom: '1px',
                          }}
                        >
                          - {translate(item.translatableText)}
                        </Text>
                      </View>
                    ))}
                    <View>
                      {/* <Avatar
                        style={{
                          width: 23,
                          height: 23,
                          backgroundColor: 'rgba(255,0,0, 0)',
                          border: '2px solid white',
                        }}
                      >
                        <Iconify color="#fff" icon="uil:info" width={17} height={17} />
                      </Avatar> */}
                      <View>
                        <Link
                          src={licenceData?.link}
                          target={'_blank'}
                          rel="noopener noreferrer"
                          style={{
                            fontSize: '12px',
                            fontFamily: 'Lato',
                            fontWeight: 'bold',
                            paddingTop: '1px',
                            paddingBottom: '1px',
                            color: 'black',
                            textDecoration: 'underline',
                          }}
                        >
                          {translate('objects.licenseMore')}
                          {licenceData?.name}
                        </Link>
                      </View>
                    </View>
                  </>
                )}
              </View>
            </View>
          )}
          <View>
            <Text style={styles.title}>{culturalObject.name && capitalizeFirst(culturalObject.name)}</Text>
          </View>
          <View style={styles.textContent}>
            {sortedArray.length > 1 &&
              [...sortedArray, dateModifed]?.map((item, id) => item.key === undefined && drawMetadata(item, id))}
          </View>
        </Page>
      </Document>
    )
  );
}
